import { render, staticRenderFns } from "./AjoutStockStallion.vue?vue&type=template&id=64ca960f&"
import script from "./AjoutStockStallion.vue?vue&type=script&lang=js&"
export * from "./AjoutStockStallion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports